(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const productSections = document.querySelectorAll('.product-single-container');
    
    productSections.forEach(function(section) {
      initProductGallery(section);
      initVariantSelection(section);
      initDescriptionToggle(section);
    });
  });

  function initProductGallery(section) {
    const sectionId = section.getAttribute('data-section-id');
    const mainImage = document.getElementById('MainProductImage-' + sectionId);
    const thumbnailCarousel = document.getElementById('ThumbnailCarousel-' + sectionId);
    if (!mainImage || !thumbnailCarousel) return;

    const thumbnailBtns = thumbnailCarousel.querySelectorAll('.product-thumbnail-btn');
    thumbnailBtns.forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        const newSrc = btn.getAttribute('data-image-url');
        if (newSrc && mainImage.src !== newSrc) {
          mainImage.src = newSrc;
          
          thumbnailBtns.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    });
  }

  function initVariantSelection(section) {
    const sectionId = section.getAttribute('data-section-id');
    const hiddenSelect = document.getElementById('ProductSelect-' + sectionId);
    if (!hiddenSelect) return;

    const optionGroups = section.querySelectorAll('.option-selector-group');
    if (optionGroups.length === 0) return;

    let selectedOptions = [];
    updateSelectedOptions();

    optionGroups.forEach(group => {
      const pills = group.querySelectorAll('.option-pill-btn');
      
      pills.forEach(pill => {
        pill.addEventListener('click', function(e) {
          e.preventDefault();
          
          pills.forEach(p => p.classList.remove('active'));
          pill.classList.add('active');
          
          updateSelectedOptions();
          updateVariantUI();
        });
      });
    });

    function updateSelectedOptions() {
      selectedOptions = [];
      optionGroups.forEach(group => {
        const activePill = group.querySelector('.option-pill-btn.active');
        if (activePill) {
          selectedOptions.push(activePill.getAttribute('data-value'));
        }
      });
    }

    function updateVariantUI() {
      const jsonScript = document.getElementById('ProductJson-' + sectionId);
      if (!jsonScript) return;
      
      try {
        const productData = JSON.parse(jsonScript.textContent);
        
        const matchedVariant = productData.variants.find(variant => {
          return variant.options.every((optVal, idx) => {
            return selectedOptions[idx] === optVal;
          });
        });
        
        const priceEl = document.getElementById('ProductPrice-' + sectionId);
        const comparePriceEl = document.getElementById('ComparePrice-' + sectionId);
        const stockDot = section.querySelector('.product-stock-status-row .stock-dot');
        const stockText = document.getElementById('StockText-' + sectionId);
        const submitBtn = document.getElementById('AddToCart-' + sectionId);
        const submitBtnText = document.getElementById('AddToCartText-' + sectionId);
        const mainImage = document.getElementById('MainProductImage-' + sectionId);
        const thumbnailBtns = section.querySelectorAll('.product-thumbnail-btn');

        if (matchedVariant) {
          hiddenSelect.value = matchedVariant.id;
          
          const matchedOption = Array.from(hiddenSelect.options).find(opt => parseInt(opt.value) === matchedVariant.id);
          if (matchedOption) {
            const priceStr = matchedOption.getAttribute('data-price');
            const comparePriceStr = matchedOption.getAttribute('data-compare-price');
            
            if (priceEl && priceStr) {
              priceEl.textContent = priceStr;
              if (comparePriceStr) {
                priceEl.classList.add('price-sale');
              } else {
                priceEl.classList.remove('price-sale');
              }
            }
            
            if (comparePriceEl) {
              if (comparePriceStr) {
                comparePriceEl.textContent = comparePriceStr;
                comparePriceEl.style.display = 'block';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }
          }
          
          if (matchedVariant.available) {
            if (stockDot) {
              stockDot.className = 'stock-dot stock-in';
            }
            if (stockText) {
              if (matchedOption) {
                const qty = matchedOption.getAttribute('data-inventory-qty');
                const management = matchedOption.getAttribute('data-inventory-management');
                if (management === 'shopify' && qty !== null) {
                  stockText.textContent = 'In stock (' + qty + ' available)';
                } else {
                  stockText.textContent = 'In stock';
                }
              } else {
                stockText.textContent = 'In stock';
              }
            }
            if (submitBtn) {
              submitBtn.removeAttribute('disabled');
            }
            if (submitBtnText) {
              submitBtnText.textContent = 'Add to cart';
            }
          } else {
            if (stockDot) {
              stockDot.className = 'stock-dot stock-out';
            }
            if (stockText) {
              stockText.textContent = 'Out of stock';
            }
            if (submitBtn) {
              submitBtn.setAttribute('disabled', 'disabled');
            }
            if (submitBtnText) {
              submitBtnText.textContent = 'Sold out';
            }
          }
          
          if (matchedVariant.featured_image && mainImage) {
            const imgSrc = matchedVariant.featured_image.src || matchedVariant.featured_image;
            if (imgSrc) {
              mainImage.src = imgSrc;
            }
            
            thumbnailBtns.forEach(btn => {
              const mediaId = btn.getAttribute('data-media-id');
              if (mediaId && parseInt(mediaId) === matchedVariant.featured_media_id) {
                thumbnailBtns.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
              }
            });
          }
        } else {
          if (submitBtn) {
            submitBtn.setAttribute('disabled', 'disabled');
          }
          if (submitBtnText) {
            submitBtnText.textContent = 'Unavailable';
          }
          if (stockText) {
            stockText.textContent = 'Unavailable';
          }
          if (stockDot) {
            stockDot.className = 'stock-dot stock-out';
          }
        }
      } catch (e) {
        console.error('Error updating variant selection:', e);
      }
    }
  }

  function initDescriptionToggle(section) {
    const sectionId = section.getAttribute('data-section-id');
    const wrapper = document.getElementById('DescriptionWrapper-' + sectionId);
    const content = document.getElementById('DescriptionContent-' + sectionId);
    const toggleBtn = document.getElementById('DescriptionToggle-' + sectionId);
    const fade = document.getElementById('DescriptionFade-' + sectionId);
    if (!wrapper || !content || !toggleBtn) return;

    const collapsedHeight = 120;
    const actualHeight = content.scrollHeight;

    if (actualHeight > collapsedHeight + 20) {
      toggleBtn.style.display = 'block';
      
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        const isExpanded = wrapper.classList.contains('expanded');
        if (isExpanded) {
          wrapper.classList.remove('expanded');
          toggleBtn.textContent = 'Show more';
          // Smooth scroll back to overview heading
          const container = wrapper.closest('.product-description-container');
          if (container) {
            container.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        } else {
          wrapper.classList.add('expanded');
          toggleBtn.textContent = 'Show less';
        }
      });
    } else {
      wrapper.style.maxHeight = 'none';
      if (fade) fade.style.display = 'none';
    }
  }

  } catch(e) { console.error(e); }
})();
})();
